import { CoralogixRum } from '@coralogix/browser'
import { getBaseConfig, CORALOGIX_PUBLIC_KEY, CORALOGIX_APPLICATION } from './rum-config'

export const isCoralogixBlockedError = (errorMessage) => {
  if (!errorMessage) return false
  return errorMessage.includes('coralogix') ||
         errorMessage.includes('cx-ingest') ||
         errorMessage.includes('NetworkError')
}

export const handleUnhandledRejection = (event) => {
  const errorMessage = event.reason?.message || String(event.reason)
  if (isCoralogixBlockedError(errorMessage)) {
    event.preventDefault()
    console.warn('Coralogix request blocked (likely by ad-blocker)')
    return true
  }
  return false
}

const getHostname = () =>
  typeof window !== 'undefined' ? window.location.hostname : ''

const isLocalhost = () => ['localhost', '127.0.0.1'].includes(getHostname())

export const initCoralogixRum = () => {
  if (!CORALOGIX_PUBLIC_KEY || !CORALOGIX_APPLICATION) {
    console.warn('Coralogix disabled: VITE_CORALOGIX_PUBLIC_KEY or VITE_CORALOGIX_APPLICATION not set')
    return null
  }

  if (isLocalhost()) return null

  try {
    CoralogixRum.init({
      ...getBaseConfig(),
      workerSupport: true,
    })
    return CoralogixRum
  } catch (error) {
    console.warn('Failed to initialize Coralogix RUM:', error)
    return null
  }
}

export const setRumLabels = (labels) => {
  try {
    CoralogixRum.setLabels(labels)
  } catch (error) {
    console.warn('Failed to set Coralogix RUM labels:', error)
  }
}
